import _extends from "@babel/runtime/helpers/extends";
/*
 *                     NOTICE
 *            COPYRIGHT 2021 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import * as AbReactResources from "abreact/generated/locale/AbReactResources";
import { ReactUtils } from "abreact/incubator/ui/utils/ReactUtils";
import { AbDateTimeCommonInput } from "abreact/input/date/AbDateTimeCommonInput";
import { ClassUtils } from "abweb/utils/ClassUtils";
import { AbCalendarDay } from "abweb/utils/date/AbCalendarDay";
import { DateTimeUtils } from "abweb/utils/date/DateTimeUtils";
import * as React from "react";

// Default min and max dates, same range as AbDateInput
export const DEFAULT_INPUT_EARLIEST_ALLOWED_DATE = AbCalendarDay.fromData({
  year: 1000,
  month: 1,
  day: 1
});
export const DEFAULT_INPUT_LATEST_ALLOWED_DATE = AbCalendarDay.fromData({
  year: 9999,
  month: 12,
  day: 31
});
const stringToDay = (s, parser) => {
  const parsed = parser.parse(s);
  if (ClassUtils.isInstanceOf(parsed, Date)) return AbCalendarDay.fromLocalDate(parsed);
  return parsed;
};
const EXAMPLE = AbCalendarDay.fromData({
  year: 2000,
  month: 12,
  day: 31
});
export const AbDateInput = props => {
  const {
    className,
    earliestDate,
    latestDate,
    format,
    value,
    ...rest
  } = props;
  const wrappedFormat = props.format ?? DateTimeUtils.DATE_SHORT;
  const earliest = AbCalendarDay.fromData(props.earliestDate ?? DEFAULT_INPUT_EARLIEST_ALLOWED_DATE);
  const latest = AbCalendarDay.fromData(props.latestDate ?? DEFAULT_INPUT_LATEST_ALLOWED_DATE);
  const wrappedValue = props.value ? AbCalendarDay.fromData(props.value) : undefined;
  const inRangeProp = React.useCallback(date => date.inRange(earliest, latest), [earliest, latest]);
  return /*#__PURE__*/React.createElement(AbDateTimeCommonInput, _extends({}, rest, {
    placeholder: props.placeholder ?? AbReactResources.datePicker_date_placeholder(),
    value: wrappedValue,
    className: ReactUtils.classNamesString([props.className, "ab-date-input"]),
    format: {
      format: day => wrappedFormat.format(day.localMidnightDate),
      parse: string => stringToDay(string, wrappedFormat),
      example: EXAMPLE
    },
    inRange: inRangeProp,
    getErrorString: (textIsValid, inRange) => {
      if (!textIsValid) return AbReactResources.datePicker_invalidDate_format(wrappedFormat.format(EXAMPLE.localMidnightDate));
      if (!inRange) return AbReactResources.datePicker_invalidDate_range(wrappedFormat.format(earliest.localMidnightDate), wrappedFormat.format(latest.localMidnightDate));
      return "";
    },
    equals: (d1, d2) => d1.equals(d2),
    buttonProps: {
      value: wrappedValue?.localMidnightDate,
      format: wrappedFormat.format,
      earliestDate: earliest.localMidnightDate,
      latestDate: latest.localMidnightDate
    }
  }));
};
//# sourceMappingURL=AbDateInput.js.map
